export default function VideoPlayer({ src, testid }) {
  return (
    <div className="bg-black border border-border p-2" data-testid={testid}>
      <video src={src} controls playsInline className="w-full max-h-[70vh] mx-auto block" style={{ aspectRatio: "9/16", objectFit: "contain" }} />
    </div>
  );
}
